module.exports = __webpack_public_path__ + "static/flags/AQ-6c187f0b1ac0b2a4539af5768864a054.gif";